/* eslint-disable */
// @ts-nocheck
import { ghb } from "@cervval.js/i18n/src/i18n.tools";

export const i18n = {
    preConfig: {
        noData: {
            description: "No data available at the moment!",
            title: "No data"
        },
        noResultInFilter: {
            description: "No matches were found for your search. Please reset your filters.",
            title: "No results"
        }
    }
};